import { TableRow } from "@mui/material";
import { formatDecimalNumber, getCalculatedPricingForProduct } from "../../../utils";
import { PriceDisplay } from "../../common/PriceDisplay";
import { StyledTableCell } from "../../table/BaseTable/BaseTable";
import { DiscountPercentInput } from "./DiscountPercentInput";
import { DiscountTotalInput } from "./DiscountTotalInput";
import { getDiscountAllowedRanges, useDiscountedPrice } from "./utils";

export const ProductRow = (props) => {
    const { product, fields, gross, readonly = false } = props;
    
    const isNoFootage = product.type?.no_footage || false;
    const pricing = getCalculatedPricingForProduct(product);
    const allowedDiscountRanges = getDiscountAllowedRanges(product);
    const discountedPriceGross = useDiscountedPrice(
        `${fields.discount}.${product.id}`,
        isNoFootage ? pricing.listed.gross_per_sqm : pricing.listed.gross,
    );
    const discountedPriceNet = useDiscountedPrice(
        `${fields.discount}.${product.id}`,
        isNoFootage ? pricing.listed.net_per_sqm : pricing.listed.net,
    );
    const discountedPriceGrossPerM2 = useDiscountedPrice(
        `${fields.discount}.${product.id}`,
        pricing.listed.gross_per_sqm,
    );
    const discountedPriceNetPerM2 = useDiscountedPrice(
        `${fields.discount}.${product.id}`,
        pricing.listed.net_per_sqm,
    );

    const totalInput = (isNoFootage) => (
        <DiscountTotalInput
            fieldName={`${fields.discount}.${product.id}`}
            range={
                gross
                    ? allowedDiscountRanges.totalAmountGross
                    : allowedDiscountRanges.totalAmountNet
            }
            productPrice={gross ? pricing.listed.gross : pricing.listed.net}
            readonly={readonly || isNoFootage}
            step={0.01}
        />
    );

    const perSquareMeterInput = () => (
        <DiscountTotalInput
            fieldName={`${fields.discount}.${product.id}`}
            range={
                gross
                    ? allowedDiscountRanges.perSquareMeterAmountGross
                    : allowedDiscountRanges.perSquareMeterAmountNet
            }
            productPrice={gross ? pricing.listed.gross_per_sqm : pricing.listed.net_per_sqm}
            readonly={readonly}
            step={0.01}
        />
    );

    return (
        <TableRow>
            <StyledTableCell>{product.product_number}</StyledTableCell>
            <StyledTableCell>{product.type?.name}</StyledTableCell>
            <StyledTableCell>{formatDecimalNumber(product.pricing.vat_proc)}%</StyledTableCell>
            <StyledTableCell>{product.footage}</StyledTableCell>
            <StyledTableCell>{formatDecimalNumber(product.pricing.discount_max)}%</StyledTableCell>
            <StyledTableCell>
                <PriceDisplay price={gross ? pricing.listed.gross : pricing.listed.net} />
            </StyledTableCell>
            <StyledTableCell>
                <PriceDisplay
                    price={gross ? pricing.listed.gross_per_sqm : pricing.listed.net_per_sqm}
                    perSquareMeter
                />
            </StyledTableCell>
            <StyledTableCell>
                <PriceDisplay price={gross ? pricing.minSale.gross : pricing.minSale.net} />
            </StyledTableCell>
            <StyledTableCell>
                <PriceDisplay
                    price={gross ? pricing.minSale.gross_per_sqm : pricing.minSale.net_per_sqm}
                    perSquareMeter
                />
            </StyledTableCell>
            <StyledTableCell>
                <DiscountPercentInput
                    fieldName={`${fields.discount}.${product.id}`}
                    range={allowedDiscountRanges.percentage}
                    readonly={readonly}
                />
            </StyledTableCell>
            <StyledTableCell>{isNoFootage ? perSquareMeterInput() : totalInput()}</StyledTableCell>
            <StyledTableCell>
                {isNoFootage ? totalInput(isNoFootage) : perSquareMeterInput()}
            </StyledTableCell>
            <StyledTableCell>
                <PriceDisplay price={gross ? discountedPriceGross : discountedPriceNet}/>
            </StyledTableCell>
            <StyledTableCell>
                <PriceDisplay price={gross ? discountedPriceGrossPerM2 : discountedPriceNetPerM2} />
            </StyledTableCell>
        </TableRow>
    );
};
